/**
 * A Simple Button.
 * 
 * @prop {Function} [onClick] 
 * 
 * @prop {Object} [style]
 * 
 * @prop {Object} [textStyle]
 * 
 * @prop {String} [label]
 * 
 * @prop {String} [backgroundColor]
 * Defaults to transparent.
 * 
 * @prop {String} [color]
 * @prop {Boolean} [white]
 * @prop {Boolean} [block]
 * 
 * @prop {String} [className]
 * 
 * @prop {Boolean} [primary]
 * @prop {Boolean} [secondary]
 * @prop {Boolean} [tertiary]
 * 
 * @prop {Boolean} [submit]
 * If true, the button will be rendered as a <button/> element with a type
 * of "submit". This can be useful when rendering in a form.
 * 
 */

import React, {forwardRef} from 'react';
import { Text } from '../Text';
import { Link, useHistory } from 'react-router-dom';
import "./index.css";



// Link and Div containers are use by Button.

export const LinkContainer = forwardRef(({to, style, ...props}, ref) => {
  return <Link to={to} style={{textDecoration:'none', ...style}} {...props} ref={ref}/>;
});

export const ButtonContainer = forwardRef((props, ref) => {
  return <button {...props} ref={ref}/>;
});

export const DivContainer = forwardRef((props, ref) => {
  return <div {...props} ref={ref}/>;
});



// Primary Button Component.

export const Button = forwardRef(({
  onClick, 
  style = {}, 
  textStyle = {},
  label,
  backgroundColor,
  color,
  block,
  children,
  parimary,
  tertiary, 
  secondary, 
  to,
  submit,
  white,
  orange,
  outline,
  className,
  ...props
}, ref) => {
  
  let Container = !!to ? LinkContainer : 
                  !!submit ? ButtonContainer : 
                  DivContainer;
  
  if(white) {
    color = "white";
  }
  if(orange) {
    color = "#ff4f00";
  }
  
  return (
    <Container 
      ref={ref}
      onClick={onClick} 
      className={
        tertiary ? `tertiary-button ${className}` : 
        secondary ? `seconary-button ${className}` :
        `button ${className}`
      }
      style={{
        backgroundColor, 
        display: block ? 'block' : null,
        ...style
      }}
      to={to}>
      {label ? <Text semibold style={{color, ...textStyle}} {...props}>{label}</Text> : children}
    </Container>
  );
});



// Special case back button with an arrow. 

export function BackButton({style, onClick, to, ...props}) {
  const history = useHistory();
  if(!onClick && !to) {
    onClick = () => history.goBack();
  }
  return (
    <Button 
      style={{
        width: 32,
        height: 32,
        marginRight: 16,
        padding: 0,
        borderRadius: 16,
        backgroundColor: "#b3b3b3",
        ...style
      }}
      to={to}
      onClick={onClick}
      {...props}>
      <svg width="18" height="18" viewBox="0 0 22.02 13.45">
        <path fill="#ffffff" d="M21.67,6.37H1.22L6.99,0.6c0.14-0.14,0.14-0.36,0-0.5c-0.14-0.14-0.36-0.14-0.5,0L0.15,6.44 C0.06,6.51,0,6.61,0,6.72C0,6.84,0.06,6.94,0.15,7l6.34,6.34c0.07,0.07,0.16,0.1,0.25,0.1s0.18-0.03,0.25-0.1 c0.14-0.14,0.14-0.36,0-0.5L1.22,7.08h20.45c0.19,0,0.35-0.16,0.35-0.35C22.02,6.53,21.87,6.37,21.67,6.37z"/>
      </svg>
    </Button>
  );
}